import * as types from '../types/user';

const initialState = {
  // isValidUser: false,
  // jwtToken: null,
  // userName: null,
  // email: null,
  // cognitoUser: null,
  // isLoggingIn: false,
  // errmessage: '',

  // isRegistering: false,
  // registerMsg: '',
  // registerStatus: null,

  loggedUserInfoView: null
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case types.USER_LOGGING_IN:
      return {
        ...initialState, isLoggingIn: true
      }
    case types.USER_LOGGED_IN:
      return {
        data: action.jwtToken, isLoggingIn: false, jwtToken: action.jwtToken,
        errormessage: action.errmessage, isValidUser: action.isValidUser, userName: action.userName, email: action.email
      }
    case types.USER_REGISTERING:
      return {
        ...initialState, isRegistering: true
      }
    case types.USER_REGISTER_COMPLETED:
      return {
        isRegistering: false, registerMsg: action.registerMsg,
        registerStatus: action.registerStatus
      }
    case types.USER_LOGGED_OUT:
      return initialState;
    case types.SET_USER_LOGGED_USER_PROFILE:
      return {
        loggedUserInfoView: action.data
      }
    case types.CLEAR_USER_LOGGED_USER_PROFILE:
      return {
        ...state,
        loggedUserInfoView: null
      }
    default:
      return state
  }
}
